import { gql } from '@apollo/client';
import { Relais } from '../../fragments/relais/relais.fragments';

const QUERY_RELAIS = gql`
  query PointRelais($address: String, $city: String, $zipCode: String!) {
    pointRelais(address: $address, city: $city, zipCode: $zipCode) {
      ...RelaisMainInfo
    }
  }
  ${Relais.fragments.relais}
`;

export default QUERY_RELAIS;
